import { ComboboxOption } from '../../interfaces/common/ComboxOption';

const naturesJuridiquesPes: ComboboxOption[] = [
  {
    key: '01',
    text: '01 Particuliers',
    value: '01',
  },
  {
    key: '02',
    text: '02 Artisan, Commerçant ou Agriculteur',
    value: '02',
  },
  {
    key: '03',
    text: '03 Société',
    value: '03',
  },
  {
    key: '04',
    text: '04 CAM ou caisse appliquant les mêmes règles',
    value: '04',
  },
  {
    key: '05',
    text: '05 Caisse complémentaire',
    value: '05',
  },
  {
    key: '06',
    text: '06 Association',
    value: '06',
  },
  {
    key: '07',
    text: '07 Etat ou organisme d\'Etat',
    value: '07',
  },
  {
    key: '08',
    text: '08 Etablissement PUBLIC national',
    value: '08',
  },
  {
    key: '09',
    text: '09 Collectivité territoriale, EPL ou EPS',
    value: '09',
  },
  {
    key: '10',
    text: '10 Etat étranger ou ambassade',
    value: '10',
  },
  {
    key: '11',
    text: '11 CAF',
    value: '11',
  },
];

export default naturesJuridiquesPes;
